import { Button, FlexBox, Icon } from '@vp/swan'
import { useOpenCallMeWidget } from '@vp/care-react-c2c'
import { useTranslation } from 'react-i18next'

interface Props {
  tenant: string
  locale: string
  disabled?: boolean
  isLoading?: boolean
}
export const CallMeButton = (props: Props) => {
  const { tenant, locale, disabled = false, isLoading = false } = props
  const { t } = useTranslation(tenant)
  const lng = locale.toLowerCase().replace('-', '_')
  return (
    <Button id="call_me_button_online" onClick={useOpenCallMeWidget()} skin="secondary" disabled={disabled} iconPosition="left">
      <FlexBox flexDirection="row" alignItems="center" gap="2">
        <Icon iconType="phone" size="standard" skin="standard" />
        <span>{isLoading ? t(`${tenant}:contact_us.button_states.loading`, { lng }) : t(`${tenant}:contact_us.channels.phone`, { lng })}</span>
      </FlexBox>
    </Button>
  )
}
